import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const LetterWithUserOutline = createIcon({
  displayName: 'LetterWithUserOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M24,0H0V24H24Z" fill="none" />
      <path
        d="M21,16v2a3,3,0,0,1-3,3H17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,9V6A3,3,0,0,1,6,3H7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14,12h4.75A2.25,2.25,0,0,0,21,9.75V5.25A2.25,2.25,0,0,0,18.75,3h-6.5A2.25,2.25,0,0,0,10,5.25V7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13,6.5l1.98914.8908a1.25,1.25,0,0,0,1.02181,0L18,6.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13,21a2.5,2.5,0,0,0-2.5-2.5h-5A2.5,2.5,0,0,0,3,21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="8"
        cy="13.5"
        r="2.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const LetterWithUser: FC<IconProps> = (props) => {
  return <CustomIcon as={LetterWithUserOutline} {...props} />
}

export default memo(LetterWithUser)
